module.exports = __webpack_public_path__ + "static/media/md.de1a8f4c.svg";